<template>
  <b-modal
    id="calc-modal"
    :title="$t('objects.costing')"
    size="xl"
    :cancel-title="$t('generals.close')"
    :ok-title="$t('generals.save')"
  >
    <!-- <b-button
      v-b-modal.calc-modal-add-edit
      class="ml-auto d-block mb-1"
      variant="primary"
      @click="openAddCalcModal"
    >
      Добавить
    </b-button> -->
    <b-table
      responsive
      :fields="fields"
      :items="GET_ONE_FLAT.calculations"
      bordered
    >
      <template #head()="data">
        <span>{{ $t(data.label) }}</span>
      </template>
      <template #empty>
        <div class="text-center">{{ $t('general.no_records_to_show') }}</div>
      </template>
      <!-- <template #cell(actions)="props">
        <div class="d-flex justify-content-around">
          <b-button
            v-b-modal.calc-modal-add-edit
            variant="warning"
            size="sm"
            class="mr-50"
            @click="editCalculation(props.item)"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button
            variant="danger"
            size="sm"
            @click="deleteCalculation(props.item.id)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </div>
      </template> -->
    </b-table>
    <add-or-edit-calculations
      :form_obj="calc_obj"
      :is-edit="is_editing"
      @saveSuccess="refresh"
    />
  </b-modal>
</template>

<script>
import {
  BTable, BModal,
  // BButton
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import formatters from '@/mixins/extra'
import addOrEditCalculations from './addOrEditCalculations.vue'

export default {
  components: {
    BTable,
    BModal,
    // BButton,
    addOrEditCalculations,
  },
  mixins: [formatters],
  props: {
    flat_id: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      is_editing: false,
      calc_obj: {
        flat: this.flat_id,
      },
      fields: [
        {
          label: 'objects.payment',
          key: 'payment_in_percent.value',
          // formatter: (value, key, item) => `${item}%`,
        },
        {
          label: 'objects.discount',
          key: 'discount_in_percent',
        },
        {
          label: 'objects.installment',
          key: 'installment',
        },
        {
          label: 'objects.price_per_m',
          key: 'new_price_per_kv',
          formatter: formatters.methods.$_moneyFormatter,
        },
        {
          label: 'objects.total_cost_of_the_apartment',
          key: 'new_total_price',
          formatter: formatters.methods.$_moneyFormatter,
        },
        {
          label: 'objects.initial_payment',
          key: 'initial_fee',
          formatter: formatters.methods.$_moneyFormatter,
        },
        {
          label: 'objects.monthly_payments',
          key: 'monthly_payment',
          formatter: formatters.methods.$_moneyFormatter,
        },
        // {
        //   key: 'actions',
        //   label: 'Действия',
        // },
      ],
      items: [],
    }
  },
  computed: {
    ...mapGetters('flats', ['GET_ONE_FLAT']),
  },
  watch: {
    flat_id() {
      this.FETCH_ONE_FLAT(this.flat_id)
    },
  },
  mounted() {
    this.FETCH_ONE_FLAT(this.flat_id).then(() => {
      this.$bvModal.show('calc-modal')
    })
  },
  methods: {
    ...mapActions('flats', ['FETCH_ONE_FLAT', 'DELETE_FLAT_CALCULATION']),
    refresh() {
      this.FETCH_ONE_FLAT(this.flat_id)
      this.$bvModal.hide('calc-modal-add-edit')
    },
    deleteCalculation(id) {
      this.$_showAreYouSureModal().then(resp => {
        if (resp) {
          this.DELETE_FLAT_CALCULATION(id).then(() => {
            this.FETCH_ONE_FLAT(this.flat_id)
            this.$_successToast(this.$t('objects.deleted'))
          }).catch(() => {
            this.$_errorToast(this.$t('objects.error'))
          })
        }
      })
    },
    openAddCalcModal() {
      this.is_editing = false
      this.calc_obj = {
        flat: this.flat_id,
      }
    },
    editCalculation(calc_data) {
      const {
        id, payment_in_percent, discount_in_percent, installment,
      } = calc_data
      this.is_editing = true
      this.calc_obj = {
        id,
        payment_in_percent: payment_in_percent.id,
        discount_in_percent,
        installment,
      }
      // this.calc_obj = this.$_removeObjectConnection(calc_data)
      // this.calc_obj.payment_in_percent = this.calc_data.payment_in_percent.id
    },
    // openAddCalcModal() {
    //   this.
    // }
  },
}
</script>

<style></style>
